<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-11">
                <div class="float-right">
                    <button class="dash-btns btn mr-3" [routerLink]="['/PayOut/PayOutTransactions']">Manage
                        PayOutTransactions</button>
                    <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                
                                <div class="text-center">
                                    <a class="view-h gary-t  ">View PayOut Transactions </a>

                                </div>

                                <div class="pt-5">



                                    <div class="row">
                                        <div class=" col-md-6">
                                            <div class="row mb-3">
                                                <button type="button" class="btn dash-btns" id="btnAddservice"  (click)="SendOtp()" *ngIf="status==5 && payoutapprove && sendotpbtn">Approve </button>
                                                <button class="btn dash-btns text-right" color="primary"
                                                (click)="Declinepopup()" *ngIf="status==5 && payoutapprove">Decline </button>  
                                              
                                            </div>
                                        </div>

                                        <div class=" col-md-6">
                                           <div class="row mb-3" *ngIf="Otptextbox">

                                                <div class="col-6 p-0"> <input class="formcontrol-user1 form-control" type="text" placeholder="Enter Otp" id="Otp" [formControl]="Otp"  name="EnterOtp" >
                                                <a href="" (click)="SendOtp()" >Resend Otp</a></div>

                                                <div class="col-6 p-3">  <button type="button" class="btn dash-btns" id="btnAddMFeeServices"  (click)="otpverfication()" [disabled]="Otp.invalid">Verify Otp</button></div>
                                                <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                                                *ngIf="Otp.invalid && (Otp.dirty || Otp.touched)">{{Otperrors()}}</div>
                                               
                                            </div>  
                                        </div>
                                    </div>


                                    





                                    <div class="row">
                                        
                                        <div class=" col-md-6">

                                         
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Status </label> </div>

                                                <div class="col-6 p-0 view-text "> 
                                                    <span class="text-warning" *ngIf="rows.Status==0">
                                                        Pending
                                                      </span>
                                                      <span class="text-success" *ngIf="rows.Status==1">
                                                        Transaction Initiated
                                                      </span>
                                                      <span class="text-danger" *ngIf="rows.Status==2">
                                                        Failed
                                                      </span>
                                                      <span class="text-success" *ngIf="rows.Status==3">
                                                        Transferred
                                                      </span>
                                                      <span class="text-danger" *ngIf="rows.Status==4">
                                                        Cancelled
                                                      </span> 
                                                      <span class="text-danger" *ngIf="rows.Status==5">
                                                       Waiting For Approval
                                                      </span> 
                                                </div>
                                                <!-- <button class="btn dash-btns text-right" color="primary"
                                                (click)="openpopup()" *ngIf="status==5 && payoutapprove">Approve </button>  
                                                <button class="btn dash-btns text-right" color="primary"
                                                (click)="Declinepopup()" *ngIf="status==5 && payoutapprove">Decline </button>   -->


                                            </div>
                                            <!-- <div class="col-md-12 pt-3"> -->
                                                <!-- <div class="text-left pt-3" *>
        
                                                        <button class="btn dash-btns" color="primary"
                                                         (click)="openpopup()">Approve </button>
        
                                                  </div>  -->
                                                <!-- </div> -->
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label> Amount </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.Amount | currency:"₹"}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>Transaction Id</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.TransactionId}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Gst Amount </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.GSTAmount}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Total Amount </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.Amount + rows.TotalFeeAmount | number : '1.2-2'}} </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Fee Amount</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.FeeAmount}}</div>
                                            </div>

                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Total Fee Amount</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.TotalFeeAmount}}</div>
                                            </div>
                                           

                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>Transaction Type </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.TransactionType}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Payment Type </label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.PaymentType}}</div>
                                            </div>
                                            <!-- <div class="row mb-3">

                                                <div class="col-6 p-0"> <label> Amount </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.Amount | currency:"₹"}}</div>
                                            </div> -->
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label> PayOut Beneficiary Key Id</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.PayOutBeneficiaryKeyId }}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>Payout Customer key Id</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> BankCode Type </label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.BankCodeType}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Bank Name</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.BankName}}</div>
                                            </div>

                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>UTRNo</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.UTRNo}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label> PayOut Date</label></div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.PayOutDate |
                                                    date:'d/M/yy, h:mm a' }}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>PayOut Key Id</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.PayOutKeyId}}</div>
                                            </div>
                                            
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"> <label>PayOut Type</label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.PayOutType}}</div>
                                            </div>
                                          
                                            <div class="row mb-3" *ngIf="CrossAccNo">

                                                <div class="col-6 p-0"><label> Account Number </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.AccountNumber}}


                                                    <span color="accent" id="fullCardNo." (click)="onSelect(true)">
                                                        <i class="fab fa-sistrix"
                                                            style="color:#41c0e8;font-size:16px; font-weight:600;"></i>
                                                    </span>
                                                </div>
                                               
                                            </div>

                                            <div class="row mb-3" *ngIf="FullAccNo">

                                                <div class="col-6 p-0"><label> Account Number </label> </div>

                                                <div class="col-6 p-0 view-text"> {{FullAccountNumber}}

                                                </div>
                                               
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Branch Name </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.BranchName}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Payout Processor </label> </div>

                                                <div class="col-6 p-0 view-text "> 
                                                    <span  *ngIf="rows.Status==0">
                                                        FastSwiffDemo
                                                      </span>
                                                      <span  *ngIf="rows.PayoutProcessor==1">
                                                        Indusind
                                                      </span>
                                                      <span  *ngIf="rows.PayoutProcessor==2">
                                                        YesBank
                                                      </span>
                                                      <span  *ngIf="rows.PayoutProcessor==3">
                                                        AxisBank
                                                      </span>
                                                      <span  *ngIf="rows.PayoutProcessor==4">
                                                        IDFC
                                                      </span> 
                                                      
                                                </div>
                                             
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> IFSC Code </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.BankCode}}</div>
                                            </div>
                                           





                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Beneficiary Name</label> </div>

                                                <div class="col-6 p-0 view-text robot"> {{rows.BeneficiaryName}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Bank Account Type </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.BankAccountType}}</div>
                                            </div>

                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Bank Country </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.BankCountry}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> UpiVpa </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.UpiVpa}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Request Reference No </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.RequestReferenceNo}}</div>
                                            </div>
                                            <!-- <div class="row mb-3">
                
                                  <div class="col-6 p-0"><label>  Status </label>  </div>
                                  
                                  <div class="col-6 p-0 view-text"> {{rows.Status}}</div>
                              </div> -->
                                            <!-- <div class="row mb-3">
                
                                <div class="col-6 p-0"><label>  ResponseCode </label>  </div>
                                
                                <div class="col-6 p-0 view-text"> {{rows.ResponseCode}}</div>
                            </div> -->
                            <div class="row mb-3">
                
                                <div class="col-6 p-0"><label>  Request UniqueId </label>  </div>
                                
                                <div class="col-6 p-0 view-text"> {{rows.RequestUniqueId}}</div>
                            </div>
                            <div class="row mb-3">
                
                              <div class="col-6 p-0"><label>  ResponseText </label>  </div>
                              
                              <div class="col-6 p-0 view-text"> {{rows.ResponseText}}</div>
                          </div>
                          
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Response Reason Code </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.ResponseReasonCode}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Created By </label> </div>

                                                <div class="col-6 p-0 view-text"> {{fname}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Approved By </label> </div>

                                                <div class="col-6 p-0 view-text"> {{firstname}}</div>
                                            </div>
                                           
                                            <div class="row mb-3">

                                                <div class="col-6 p-0"><label> Updated Date Time </label> </div>

                                                <div class="col-6 p-0 view-text"> {{rows.UpdatedDatetime| date:'d/M/yy,
                                                    h:mm a'}}</div>
                                            </div>
                                           
                                        </div>
                                        <div class="col-md-12 pt-3">
                                            <div class="row" *ngIf="Recivieddata">

                                                <div class="col-3 p-0"> <label>Received From</label> </div>
    
                                                <div class="col-8 p-0"> {{rows.PayoutCustomerkeyId}} - <b>{{Reciviedfrom}}</b>
                                                   <p><a [routerLink]="['/PayOut/ViewPayOutContact',{Id: rows.Id}]" data-toggle="tooltip">See Customer Details</a></p>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div class="col-md-12 pt-3">
                                            <div class="text-left pt-3" *ngIf="cancellbutton">

                                                <button class="btn dash-btns" id="Savecoupon" color="primary"
                                                    style="font-size: 17px;" (click)="SchedulePayment()">Cancel Schedule
                                                    Payment </button>

                                            </div>
                                        </div>
                                   
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>